import { Typography } from "@mui/material";
import DivChip from "./DivChip";
import Grid from "@mui/material/Unstable_Grid2";
//photo
import "./brand.css";
import logoEN from "../../../assetes/Forosh/LOGO EN.png";
const Brand = () => {
  return (
    <>
      <div>
        <DivChip text="Supplier"></DivChip>
        <Grid>
          <Typography variant="h6" sx={{ mb: 3, ml: 3 }}>
            We use these Brands in projects:
          </Typography>
        </Grid>
        <Grid container>
          <Grid>
            <img className="en-brand" src={logoEN} alt="Logo"></img>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
export default Brand;
